import axios, { AxiosRequestConfig } from 'axios'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import type { MassUploadResponseType } from 'utils/apiList/massUpload'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

const multipartType = 'multipart/form-data'

export const getDepartementList = () =>
  axios.get(`${baseUrl}/api/staff-management/admin/all-department-list`)

export const postUploadWorkingSchedule = (data: FormData) =>
  axiosInstanceApiGateway.Post({
    url: '/staff-management/internal/:version/schedule/bulk-upload',
    version: 'v1',
    data,
    config: {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': multipartType,
      },
    },
    convertResponse: true,
  })

export const postUploadManPowerPlanning = (data: FormData) =>
  axios.post(`${baseUrl}/api/staff-management/budget/planning`, data, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': multipartType,
    },
  })

export const postUploadManPowerBudget = (data: FormData) =>
  axios.post(`${baseUrl}/api/staff-management/budget/location`, data, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': multipartType,
    },
  })

export const getWorkingScheduleBulkUploadTemplate = (params: {
  start_date: string
  end_date: string
  location_id: number
  department: string
}) =>
  axiosInstanceApiGateway.Get({
    url: '/staff-management/internal/:version/schedule/generate-template',
    version: 'v1',
    params,
  })

export const getPlanningBulkUploadTemplate = (params: {
  start_date: string
  end_date: string
  location: number
}) => axios.get(`${baseUrl}/api/staff-management/budget/planning/template`, { params })

export const getBudgetBulkUploadTemplate = (params: { start_date: string; end_date: string }) =>
  axios.get(`${baseUrl}/api/staff-management/budget/location/template`, { params })

export const postUploadManPowerRateCard = (data: FormData, config: AxiosRequestConfig) =>
  axios.post<MassUploadResponseType>(
    `${baseUrl}/api/staff-management/budget/rate-card`,
    data,
    config,
  )

export const getRateCardBulkUploadTemplate = () =>
  axios.get<{ data: { url?: string; file_url: string } }>(
    `${baseUrl}/api/staff-management/budget/rate-card/template`,
  )
